import i18n from '@/i18n'
import useConfirmModal from '@/composables/useConfirmModal'

export const DEFAULT_CONFIRM_PARAMS = {
    header: String(i18n.global.t('dialog.discardChanges.title')),
    message: String(i18n.global.t('dialog.discardChanges.message')),
    type: 'discard' as const
}

/**
 * Composable for modal close confirmation.
 */
export function useConfirmBeforeClose () {
    function closeWithConfirm (closeFn: () => void) {
        useConfirmModal(DEFAULT_CONFIRM_PARAMS).then((isConfirmed) => {
            if (isConfirmed) {
                closeFn()
            }
        })
    }

    return { closeWithConfirm }
}
